import React, { useRef } from "react";
import "./invoice.css";
import { useLocation } from "react-router-dom";

const InvoicePage = () => {
  const { state } = useLocation();
  const invoice = state?.invoice;
  const company = state?.company || {};
  const user = state?.user || {};
  const invoiceRef = useRef();

  console.log("Invoice Data:", user);

  if (!invoice) return <div>No Invoice Data</div>;

  // ✅ Format helpers
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN");
  };

  const formatCurrency = (value) => {
    return `₹ ${Number(value || 0).toLocaleString("en-IN")}`;
  };

  // ✅ Print function
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const printContent = invoiceRef.current.innerHTML;
    const styles = document.querySelector("link[href*='invoice.css']")?.href;

    printWindow.document.write(`
      <html>
        <head>
          <title>${invoice.type?.toUpperCase() || "INVOICE"} - ${invoice.invoiceNumber}</title>
          <link rel="stylesheet" href="${styles}" />
          <style>
            body { margin: 0; padding: 20px; }
            .no-print { display: none; }
            .invoice-page { margin: 0; padding: 0; }
            button { display: none; }
          </style>
        </head>
        <body>
          <div class="invoice-page">${printContent}</div>
          <script>
            window.onload = () => { window.print(); window.close(); };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ✅ Download as PDF (using browser print to PDF)
  const handleDownloadPDF = () => {
    const originalTitle = document.title;
    document.title = `${invoice.type?.toUpperCase() || "INVOICE"}_${invoice.invoiceNumber}`;
    window.print();
    document.title = originalTitle;
  };

  return (
    <div className="invoice-page" ref={invoiceRef}>
      {/* PRINT/DOWNLOAD BUTTONS - visible only on screen, hidden when printing */}
      <div className="action-buttons no-print" style={{ marginBottom: "20px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <button onClick={handlePrint} style={{ padding: "8px 16px", cursor: "pointer" }}>
          🖨️ Print
        </button>
        <button onClick={handleDownloadPDF} style={{ padding: "8px 16px", cursor: "pointer" }}>
          📄 Download PDF
        </button>
      </div>

      {/* HEADER */}
      <div className="card">
        <div className="header-row">
          <img
            src="/assets/images/thurent-favicon.svg"
            alt="logo"
            className="logo"
          />

          <div>
            <h3>{company?.name || "Company Name"}</h3>
            <p>
              {company?.address}, {company?.city}, {company?.state} -{" "}
              {company?.pincode}
            </p>
            <p>GSTIN: {company?.gstin}</p>
            <p>
              📞 {company?.mobile} | ✉ {company?.email}
            </p>
          </div>
        </div>

        <h2 className="title">
          {invoice.type?.toUpperCase() || "INVOICE"}
        </h2>

        <p>{invoice.invoiceNumber}</p>
        <p>Date: {formatDate(invoice.generatedDate)}</p>
      </div>

      {/* PARTY DETAILS */}
      <div className="row">
        <div className="card">
          <h4>Bill To</h4>
          <p>{user?.firstName || "Customer"}</p>
          <p>{user?.mobileNumber || "-"}</p>
          <p>{user?.email || "-"}</p>
        </div>

        <div className="card">
          <h4>Event Details</h4>
          <p>{invoice.eventTitle || "-"}</p>
          <p>{formatDate(invoice.eventDate)}</p>
          <p>{invoice.venue || "-"}</p>
        </div>
      </div>

      {/* ITEMS */}
      <div className="card">
        <h3>Service Details</h3>

        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Provider</th>
              <th>Amount</th>
            </tr>
          </thead>

          <tbody>
            {invoice.items?.length > 0 ? (
              invoice.items.map((item, i) => (
                <tr key={i}>
                  <td>{item.description}</td>
                  <td>{item.providerName}</td>
                  <td>{formatCurrency(item.total)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">No items available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* SUMMARY */}
      <div className="card">
        <div className="summary-row">
          <span>Subtotal</span>
          <span>{formatCurrency(invoice.subtotal)}</span>
        </div>

        <div className="summary-row">
          <span>Tax</span>
          <span>{formatCurrency(invoice.totalTax)}</span>
        </div>

        <hr />

        <div className="summary-row bold">
          <span>Grand Total</span>
          <span>{formatCurrency(invoice.grandTotal)}</span>
        </div>
      </div>

      {/* BANK DETAILS */}
      {invoice.type !== "estimate" && (
        <div className="card">
          <h4>Bank Details</h4>
          <p>Account Name: {company?.accountName || "-"}</p>
          <p>Account No: {company?.accountNumber || "-"}</p>
          <p>Bank: {company?.bankName || "-"}</p>
          <p>IFSC: {company?.ifscCode || "-"}</p>
        </div>
      )}

      {/* TRANSACTIONS */}
      {invoice.paymentSummarys?.length > 0 &&
        invoice.paymentSummarys.map((summary, i) => (
          <div className="card" key={i}>
            <h4>{summary.providerType}</h4>

            <table>
              <thead>
                <tr>
                  <th>Gateway</th>
                  <th>Payment ID</th>
                  <th>Amount</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {summary.transactions?.length > 0 ? (
                  summary.transactions.map((t, j) => (
                    <tr key={j}>
                      <td>{t.gateway || "-"}</td>
                      <td>{t.paymentId || "-"}</td>
                      <td>{formatCurrency(t.paidAmount)}</td>
                      <td>{formatDate(t.paidAt)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No transactions</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ))}

      {/* SIGNATURE */}
      {invoice.type === "invoice" && (
        <div className="card signature">
          <h4>Authorization</h4>

          <div className="signature-row">
            <div>
              <div className="signature-box">
                Authorized Signature
              </div>
              <p>{company?.name}</p>
              <small>Authorized Signatory</small>
            </div>

            <div className="right">
              <p>For {company?.name}</p>
              <br />
              <small>Authorized Signatory</small>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoicePage;